// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__8dqUm","avatar__image":"avatar_avatar__image__eRplC","avatar__loader":"avatar_avatar__loader__SgUr2","avatar__icon":"avatar_avatar__icon__N7_91"};